import { createApp } from 'vue'
import App from './App.vue'
// Do NOT import @mybonet/design/main.css — its global body/nav/.hero dark theme
// overrides CDN marketing packages (Botanica / BoomKicks / …).
import './style.css'
import { installVueErrorReporting } from './clientLog'

const apiBase = (import.meta.env.VITE_API_BASE as string | undefined) !== undefined
  ? (import.meta.env.VITE_API_BASE as string)
  : import.meta.env.PROD
    ? ''
    : 'http://127.0.0.1:5055'

const app = createApp(App)
installVueErrorReporting(app, apiBase, 'app-shell')
app.mount('#app')

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* ignore SW failures on preview hosts */
    })
  })
}